import script from "./MetalsRate.vue?vue&type=script&setup=true&lang=js"
export * from "./MetalsRate.vue?vue&type=script&setup=true&lang=js"

import "./MetalsRate.vue?vue&type=style&index=0&id=6991924a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6991924a"]])

export default __exports__